import { render, staticRenderFns } from "./walletStatisticsTable.vue?vue&type=template&id=0374f331&scoped=true&"
import script from "./walletStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./walletStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./walletStatisticsTable.vue?vue&type=style&index=0&id=0374f331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374f331",
  null
  
)

export default component.exports